import LearnPageLayout from "@/components/LearnPageLayout";
import { page7 } from "./learnDataP7";

const DepressionWithoutMedicationPage = () => (
  <LearnPageLayout
    title={page7.title}
    description={page7.description}
    canonical={page7.canonical}
    h1={page7.h1}
    breadcrumbLabel={page7.breadcrumbLabel}
    crumbs={page7.crumbs}
    shortAnswer={page7.shortAnswer}
    keyTakeaways={page7.keyTakeaways}
    sections={page7.sections}
    faqs={page7.faqs}
    sources={page7.sources}
    schemaJson={page7.schemaJson}
    relatedLinks={page7.relatedLinks}
  />
);

export default DepressionWithoutMedicationPage;
